import React, { useState } from 'react';
import './Experience.css';
import AppBar from "../atoms/AppBar";
import ExperienceItem from "./ExperienceItem";
import experiences from '../../Data/jsons/experiences.json';
import { FaGraduationCap, FaRobot, FaEye, FaBrain } from 'react-icons/fa';

const Experience = () => {
	const [activeTab, setActiveTab] = useState('Research');

	const handleTabChange = (tab) => {
		setActiveTab(tab);
	};

	const tabToDataMap = {
		'Research': 'researchAssistant',
		'Teaching': 'teachingAssistant',
		'Professional': 'workExperience'
	};

	const visibleExperiences = experiences[tabToDataMap[activeTab]] || [];

	// Calculate experience statistics
	const totalYears = 5;
	const researchProjects = 12;
	const publications = 9;
	const awards = 3;

	const experienceStats = [
		{ label: 'Years Experience', value: totalYears, icon: <FaGraduationCap size={20} /> },
		{ label: 'Research Projects', value: researchProjects, icon: <FaRobot size={20} /> },
		{ label: 'Publications', value: publications, icon: <FaEye size={20} /> },
		{ label: 'Awards', value: awards, icon: <FaBrain size={20} /> }
	];

	const technicalSkills = {
		'Computer Vision': ['Object Detection', 'Scene Understanding', 'Multi-modal Fusion', 'Symbolic Reasoning', 'Visual Question Answering'],
		'Robotics & Planning': ['Motion Planning', 'Task Planning', 'Logic Programming', 'Constraint Satisfaction', 'Robot Operating System'],
		'Machine Learning': ['Deep Learning', 'Reinforcement Learning', 'Probabilistic Programming', 'Machine Learning Integration']
	};

	return (
		<div className="experience-page">
			<AppBar />

			<div className="experience-main-content">
				<header className="experience-header">
					<div className="hero-text">
						<h1 className="hero-title">Experience</h1>
						<p className="hero-subtitle">
							Building intelligent systems.
						</p>
					</div>
					<div className="experience-stats">
						{experienceStats.map((stat, index) => (
							<div key={index} className="stat-item">
								<div className="stat-icon">{stat.icon}</div>
								<div className="stat-text">
									<span className="stat-val">{stat.value}+</span>
									<span className="stat-lab">{stat.label}</span>
								</div>
							</div>
						))}
					</div>
				</header>

				<div className="filters-bar">
					<div className="filter-tabs">
						{['Research', 'Teaching', 'Professional'].map(tab => (
							<button
								key={tab}
								className={`filter-tab ${activeTab === tab ? 'active' : ''}`}
								onClick={() => handleTabChange(tab)}
							>
								{tab}
								<span className="tab-count">
									{experiences[tabToDataMap[tab]]?.length || 0}
								</span>
							</button>
						))}
					</div>
				</div>

				<section className="experience-list-section">
					<div className="experience-list">
						{visibleExperiences.map((experience, index) => (
							<ExperienceItem key={index} {...experience} />
						))}
					</div>
				</section>
			</div>
		</div>
	);
};

export default Experience;
